export default "__VITE_ASSET__CCIO2bIL__"